<template>
    <div>
        <div class="page-header pr-0">
            <h2><a href="/dashboard"><i class="fas fa-tachometer-alt"></i></a></h2>
            <ol class="breadcrumbs">
                <li class="active"><span>Zonas</span></li>
            </ol>
            <div class="right-wrapper pull-right">
                    <button type="button" class="btn btn-custom btn-sm  mt-2 mr-2" @click.prevent="clickCreate()"><i class="fa fa-plus-circle"></i> Nuevo</button>

            </div>
        </div>
        <div class="card mb-0">
            <div class="card-header bg-info">
                <h3 class="my-0">Listado de Zonas
                    <template v-if="type === 'clients'">
                        <el-tooltip content="Zona para cliente y proveedor"
                            placement="top"
                            effect="dark"
                        >
                            <i class="fas fa-info-circle ml-2"></i>
                        </el-tooltip>
                    </template>
                </h3>
            </div>
            <div class="card-body">
                <data-table :resource="resource">
                    <tr slot="heading">
                        <th>#</th>
                        <th>Nombre</th>
                        <th class="text-right">Acciones</th>
                    </tr>
                    <tr slot-scope="{ index, row }"
                        :class="{ 'text-danger': !row.active }"
                    >
                        <td>{{ index }}</td>
                        <td>{{ row.name }}</td>
                        <td class="text-right">
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-info" @click.prevent="clickCreate(row.id)">Editar</button>
                            <button type="button" class="btn waves-effect waves-light btn-xs btn-danger" @click.prevent="clickDelete(row.id)">Eliminar</button>
                            <button type="button" class="btn waves-effect waves-light btn-xs" @click.prevent="clickDisable(row.id, row.active)"
                                :class="[ row.active ? 'btn-warning' : 'btn-success' ]"
                            >
                                {{ row.active ? 'Inhabilitar' : 'Habilitar' }}
                            </button>
                        </td>
                    </tr>
                </data-table>
            </div>

            <category-form
                :showDialog.sync="showDialog"
                :recordId="recordId"
                :type="type"
                    ></category-form>
        </div>
    </div>
</template>

<script>

    import CategoryForm from './form.vue'
    import DataTable from '../../../../../../../resources/js/components/DataTable.vue'
    import {deletable} from '../../../../../../../resources/js/mixins/deletable'

    export default {
        mixins: [deletable],
        components: {DataTable, CategoryForm},
        props: {
            type: {
                type: String,
                default: 'clients'
            },
            resource: {
                type: String,
                default: 'zones'
            }
        },
        data() {
            return {
                title: null,
                showDialog: false,
                // resource: 'zones',
                recordId: null,
            }
        },
        created() {
            this.title = 'Zonas'
        },
        methods: {
            clickCreate(recordId = null) {
                this.recordId = recordId
                this.showDialog = true
            },
            clickDelete(id) {
                this.destroy(`/${this.resource}/${id}`).then(() =>
                    this.$eventHub.$emit('reloadData')
                )
            },

            clickDisable(id, active) {
                this.$confirm('¿Estas seguro de inhabilitar la zona?', 'Advertencia', {
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'
                })
                .then(async () => {
                    try {
                        const { data } = await this.$http.post(`/zones/disable`, {
                            id,
                            active
                        })
                        if (data.success) {
                            this.$message.success(data.message)
                            this.$eventHub.$emit('reloadData')
                        } else {
                            this.$message.error(data.message)
                        }
                    } catch (error) {
                        let message = error.response.data.message || 'Ocurrio un error inesperado'
                        this.$message.error(message)
                    }
                })
                .catch(() => {})
            }
        }
    }
</script>



// WEBPACK FOOTER //
// modules/Item/Resources/assets/js/views/zone/index.vue